module.exports = __webpack_public_path__ + "5889962121be7b3b25d5f654da31f0a5.MP3";